<div
    class="page-static public-portal-right-col"
    style="height: 100%">
    <div class="form-screen">
        <div class="img-wrapper">
            <img
                alt="Welltrack"
                src="./assets/img/welltrack-boost-circle.png"
                style="width: 122px; height: auto" />
        </div>

        <div class="title-wrapper">
            <h1 class="title text-center" style="margin-bottom: 40px">
                Privacy Policy
            </h1>

            <p>
                Welcome to the Protocall Services, Inc. Privacy Policy
                ("Policy"). Please read this Policy carefully because it governs
                how we protect your privacy. If you download, install, access,
                or use our websites including protocallservices.com,
                welltrack.com, welltrack-boost.com, welltrack-connect.com,
                nmcrisisline.com, and our mobile applications Welltrack Boost
                and NM Connect, our New Mexico Crisis and Access Line (NMCAL),
                New Mexico Peer to Peer Warmline or any third party (our
                "Services"), you will be immediately bound by this Policy.
            </p>

            <h2>Who is Covered Under this Privacy Policy?</h2>
            <p>
                This Policy applies to any party who is 13 years of age or older
                and who downloads, installs, accesses, or uses our Services or
                accepts our Terms of Use ("Terms").
            </p>

            <h2>
                What Information is Collected, Stored, Used, or Transferred?
            </h2>
            <p>
                We may collect, store, use, or transfer the following Personal
                Information we receive from you or third parties:
            </p>
            <ul>
                <li>
                    personally identifiable information including but not
                    limited to your name, physical address, email address, and
                    telephone number.
                </li>
                <li>
                    demographic data including but not limited to sex, gender,
                    and birthdate;
                </li>
                <li>
                    health information including personal medical records,
                    statements, and admissions;
                </li>
                <li>insurance information;</li>
                <li>
                    financial details from any payment cards you submit to our
                    Services or any transactions or payments you may complete or
                    attempt to complete in or through our Services;
                </li>
                <li>
                    geolocation data including but not limited to your internet
                    service provider ("ISP") and internet protocol ("IP")
                    addresses;
                </li>
                <li>
                    device information including but not limited to brand, type,
                    serial number, software, and carrier;
                </li>
                <li>
                    personal preference information including but not limited to
                    browser type, language preference, referred sites, web
                    beacons, and user cookies; and
                </li>
                <li>
                    information about your access and use of our Services
                    including but not limited to what you access and the date,
                    time and duration of your access.
                </li>
            </ul>

            <h2>How Is This Information Protected?</h2>
            <p>
                We will only disclose your Personal Information to provide or
                improve our Services, respond to your requests or feedback,
                protect your safety or the safety of others against risk of
                serious mental or physical harm, protect our rights, or comply
                with applicable law or any government order. We will only
                disclose your Personal Information in an aggregated,
                unidentifiable form, or if we believe it necessary to do
                otherwise, we will disclose only the minimum information
                necessary and will take commercially reasonable steps to notify
                you if legally permissible. We will not disclose your
                information for sale without your consent. We may disclose
                Personal Information to employees, agents, or third parties if
                those employees, agents, or third parties have expressly agreed
                in writing not to disclose your Personal Information except in
                accordance with this Policy.
            </p>
            <p>
                If we merge, are acquired, or are purchased, in whole or part,
                for any reason, we will require any merging, acquiring, or
                purchasing party to agree to use commercially reasonable privacy
                measures to protect your Personal Information and to take
                commercially reasonable steps to notify you if your Personal
                Information becomes subject to a different party or privacy
                policy. However, you agree that any merging, acquiring, or
                purchasing party may continue to collect, store, and use your
                Personal Information according to this Policy.
            </p>
            <p>
                We will only permit the transfer of your Personal Information
                across international borders if we can ensure the transfer
                conforms with standards of the European Union General Data
                Protection Regulation ("GDPR").
            </p>
            <p>
                We may send you feedback requests about our Services unless you
                opt out. We will not disclose any Personal Information in your
                responses or feedback except in accordance with this Policy.
            </p>
            <p>
                We do not offer our Services to anyone under the age of 13
                ("minors"). We do not knowingly solicit or collect Personal
                Information from minors, and we will not knowingly host any
                third-party sites or provide links to any third-party sites that
                solicit or collect Personal Information from minors. If we learn
                we have received Personal Information from a minor, we will
                delete that information.
            </p>

            <h2>What Does This Policy Not Cover?</h2>
            <p>
                This Privacy Policy does not cover the privacy practices of
                third parties and does not protect Personal Information
                collected, stored, or used by third parties. We are not
                responsible for third-party content available in or through our
                Services including links to or advertisements for any
                third-party products or services.
            </p>

            <h2>
                How Can I Access, Update, or Delete My Personal Information?
            </h2>
            <p>
                To access, update, receive, or delete your Personal Information,
                you may submit a request to the contact e-mail address below. We
                cannot guarantee how quickly your request will be fulfilled or
                the extent to which your request can be fulfilled. If you
                request to have your Personal Information deleted, we will only
                retain the minimum necessary Personal Information to provide or
                improve our Services, respond to your requests or feedback,
                protect your safety or the safety of others against risk of
                serious mental or physical harm, protect our rights, or comply
                with applicable law or any government order.
            </p>
            <p>Email: info&#64;protocallservices.com</p>

            <h2>What happens if my Personal Information is Breached?</h2>
            <p>
                If we discover that your Personal Information has been breached
                by an unauthorized third party, we will take commercially
                reasonable steps to notify you in or through our Services or by
                e-mail as required by law.
            </p>

            <h2>What else do I need to know?</h2>
            <p>
                We may modify this Policy at any time and any modification will
                have immediate effect. If this Policy is modified, we will take
                commercially reasonable steps to notify you in or through our
                Services or by e-mail. If you do not agree to the modified
                Policy, you may not access our services.
            </p>

            <b>LAST UPDATE</b>: June 30, 2026
        </div>
    </div>
</div>
